/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface ConflictingAppointment { 
    id: number;
    startDate: string;
    endDate: string;
    patientName: string;
    appointmentTypeName: string;
    appointmentStatus: string;
}
export const ConflictingAppointment_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ConflictingAppointment_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ConflictingAppointment_endDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ConflictingAppointment_patientName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ConflictingAppointment_appointmentTypeName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ConflictingAppointment_appointmentStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];


